import Splide from '@splidejs/splide';

const EL = '.js-reviews-carousel';
const ACTIVE_CLASS = 'is-active';

if (document.querySelector(EL)) {
  const slider = new Splide(EL, {
    type: 'fade',
    pagination: true,
    arrows: false,
  }).mount();
}
